module.exports = __webpack_public_path__ + "img/编组.97de2da4.png";